import { FC } from "react";
import { Navigation, Section } from "../../../@component/layout";
import { Button } from "../../../@component/buttons";
import { Footer } from "../../../@component/layout/footer";
import {ContactUsLite} from "../../../@component/sections/contact-us-lite";
import {ArticleText} from "../../../@component/sections/article-text";
import { Images } from "../../../@assets/images";

export const Article1: FC = (props) => {


    return (
        <Section>
            <Navigation>
                <Button>hallo</Button>
            </Navigation>
            <ArticleText
                title="Menentukan Tim dengan Aplikasi Digital Terbaik, EKRAF
                Meluncurkan Demo Day Program BEKUP Create 2025"
                img={Images.design.article1}
                texts={[
                    {
                        title: "",
                        desc: `
<p>Program inisiatif dari Kementerian Ekonomi Kreatif Republik Indonesia, yaitu BEKUP 2025, kini telah memasuki tahapan Demo Day di bulan November 2025. Demo Day BEKUP di tahun ini terbagi menjadi dua, sesuai dengan berjalannya program menjadi BEKUP Create Graduation &amp; Demo Day pada 18 November 2025, serta BEKUP Accelerate Demo Day 28 November 2025.</p>
<br>
<p>BEKUP Create Graduation &amp; Demo Day pada Selasa, 18 November 2025 akan mengundang lima tim terbaik dari Capstone Project, yang telah menghasilkan prototipe aplikasi yang inovatif setelah melalui proses pendampingan yang intensif dari fasilitator dan juga advisor. Lima terbaik dari Capstone Project tersebut adalah:</p>
<ol>
    <li><p><strong>Adatverse: </strong>Aplikasi edukatif dengan teknologi Augmented Reality (AR) yang memperkenalkan budaya nusantara melalui pengalaman interaktif.</p></li>
    <li><p><strong>BooLe: </strong>Aplikasi yang membantu wisatawan asing menjelajahi Indonesia dengan mudah melalui fitur panduan lengkap destinasi, bahasa, transportasi, budaya, dan layanan darurat.</p></li>
    <li><p><strong>Jejak Cerita Rakyat: </strong>Aplikasi edukatif yang memperkenalkan budaya Indonesia kepada generasi muda lewat cerita rakyat interaktif lengkap dengan teks, ilustrasi, dan narasi suara.</p></li>
    <li><p><strong>Smart Nota: </strong>Aplikasi berbasis OCR yang membantu UMKM mendigitalisasi nota transaksi secara otomatis dan mencatat data transaksi untuk laporan keuangan yang rapi dan efisien.</p></li>
    <li><p><strong>WargaKita </strong>Aplikasi yang meningkatkan kebersamaan warga melalui dua fitur utama yaitu pembuatan acara dan peminjaman barang sehingga warga dapat saling membantu dan berkolaborasi.</p></li>
</ol>
<br>
<p>Dilaksanakan di Trembesi Tower, Tangerang, sesi BEKUP Create Graduation &amp; Demo Day akan menjadi ajang di mana para Top 5 terpilih untuk pitching di hadapan para juri dari ekosistem startup Indonesia untuk menentukan tiga Capstone Project terbaik di BEKUP Create tahun ini. Para juri dari BEKUP Create Graduation &amp; Demo Day adalah Menhariq Noor (Ketua Tim Cyber Drone 9, Kementerian Komunikasi dan Digital Republik Indonesia), Hari Sungkari (Co-Founder dan Komisaris, PT Mitra Mandiri Informatika), Amalia Aini (VP of Fund Creation, Living Lab Venture), dan Novan Adrian (Co-Founder, Qasir.id).</p>
<br>
<p>Selain itu, sesi Graduation &amp; Demo Day kali ini pun turut mengajak para peserta yang hadir dan menonton untuk mengikuti dan mendapatkan insight terkait perkembangan industri teknologi dan AI melalui diskusi panel. Sesi panel ini mengundang Ir. Dito Eka Cahya, S.T., Ph.D (Exec. Chairman AI Forum Indonesia), Ditto Anindita (Founder &amp; CEO, Botika), dan dimoderatori oleh Azhar Muhammad Fuad (CEO, Curaweda).</p>
<br>
<p>Dapatkan informasi terkini seputar hasil dari BEKUP Create Graduation &amp; Demo Day pada Instagram resmi BEKUP @bekup.bekraf.</p>`
                    }
                ]}
            />
            <ContactUsLite />
            <Footer />
        </Section>
    );
};
